import type { FC } from 'react';

import type IconProps from './IconProps';

const OfflineIcon: FC<IconProps> = (props) => {
  const { onClick, className } = props;
  const cursor = onClick ? 'cursor-pointer' : '';

  return (
    <svg onClick={onClick} className={`inline ${cursor} ${className}`} viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M10 15.9167H10.0096" stroke="#5A5766" strokeWidth="1.67552" strokeLinecap="round" strokeLinejoin="round" />
      <path
        d="M7.08325 13.4166C8.44042 12.0595 10.4183 11.8075 12.0833 12.6606"
        stroke="#5A5766"
        strokeWidth="1.25664"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.58325 10.9167C5.83325 9.66658 7.02215 9.12792 8.33325 8.83323"
        stroke="#5A5766"
        strokeWidth="1.25664"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.4167 10.9167C14.1727 9.81625 12.7373 9.06183 11.25 8.83333"
        stroke="#5A5766"
        strokeWidth="1.25664"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M1.66675 8.41669C2.91675 7.16677 4.13456 6.46879 5.41675 5.91677"
        stroke="#5A5766"
        strokeWidth="1.25664"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.3334 8.41658C15.0598 5.65228 11.4469 4.60733 7.91675 5.28173"
        stroke="#5A5766"
        strokeWidth="1.25664"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M1.66675 2.16667L18.3334 18.8333" stroke="#5A5766" strokeWidth="1.25664" strokeLinecap="round" />
    </svg>
  );
};

export default OfflineIcon;
